"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // Used for formatting numeric unix epoch timestamps into strings.
// Can easily be extended to accept other date formats, just needs some testing
// Can return a date string e.g. MM/DD/YYYY
// Can also return a dateTime e.g. MM/DD/YYYY - hh:mm a


var DateTimeFormatter = function DateTimeFormatter(_ref) {
  var value = _ref.value,
      format = _ref.format; // Unix epoch to human readable date time

  var formatVal = function formatVal(epoch) {
    if (!!epoch) {
      return (0, _moment["default"])(epoch).utc().format(format);
    } // If no date is given, display nothing in table cell


    return "";
  };

  return formatVal(value);
};

DateTimeFormatter.defaultProps = {
  format: "MM/DD/YYYY"
};
DateTimeFormatter.propTypes = {
  value: _propTypes["default"].any,
  format: _propTypes["default"].string
};
var _default = DateTimeFormatter;
exports["default"] = _default;